import { render } from "./CreateWantedGroupModal.vue?vue&type=template&id=38595c9a&scoped=true"
import script from "./CreateWantedGroupModal.vue?vue&type=script&lang=js"
export * from "./CreateWantedGroupModal.vue?vue&type=script&lang=js"

import "./CreateWantedGroupModal.vue?vue&type=style&index=0&id=38595c9a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38595c9a"]])

export default __exports__